/**
 * @author xyguo
 * @description 岗位能力星级管理
 * @Date  2020/7/19
 */
import React from "react";
import { connect } from "dva";
import createColumns from "./config";
import { Col, Row, Spin } from 'antd';
import { component_tool, framework_tool, utils_tool } from '../../../../tool';
import { WizButton } from "wiz-components/lib";
import { handleExportHeader } from '@/utils/handleTabelHeaderUtils';
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizCard, WizBrowserExport, WizTabs, WizDataTable, WizAlert, WizModal } = component_tool;
let { getPageData, Session } = utils_tool;
class AbilityCheckItemList extends WizContainer {
  componentName = 'abilityCheckItemList';

  constructor(props) {
    super(props);
    let initialValue = {};
    if (props.history.location && props.history.location.pathname === '/train/abilityCheckCategory/abilityCheckItem') {
      if (props.history.location && props.history.location.record) {
        initialValue = props.history.location.record;
        if (initialValue.id) {
          initialValue.categoryId = initialValue.id;
        }
        if (initialValue.name) {
          initialValue.categoryName = initialValue.name;
        }
        Session.set('abilityCheckItem', initialValue)
      } else {
        initialValue = Session.get('abilityCheckItem') || {};
      }
    }
    this.state = {
      selectedRows: 0,
      rows: [],
    }
    this.initialValue = initialValue;
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleFile(nextProps, nextState, key) {
    let o = nextProps['abilityCheckItemExport']
    if (o['success']) {
      let headList = o.data['headList']
      let dataList = o.data['dataList']
      WizBrowserExport({
        title: '能力评估星级信息',
        sheetName: '能力评估星级信息',
        columns: handleExportHeader(headList).filter((_, index) => index),
        rows: dataList,
        filename: '能力评估星级信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _componentDidMount() {
    const { history } = this.props;
    this.getDataList();//默认获取
  }

  /**能力评估星级列表 */
  getDataList(other = {}) {
    let apiParams = { abilityCheckCategoryId: this.initialValue.categoryId, ...this.state.apiParams }
    this.doAction({
      path: 'abilityCheckItem/listByPage',
      payload: {
        key: 'abilityCheckItem',
        apiParams: { ...apiParams, ...other }
      },
      autoInit: true,
    })
  }

  _removeSelectedRows = () => {
    this.setState({
      selectedRows: 0,
      rows: [],
    })
  };

  _add = (categoryData) => {
    this.jumpPage('push', '/train/abilityCheckCategory/abilityCheckItem/abilityCheckItemAdd', { ...categoryData });
  }

  _export = (categoryData) => {
    // categoryData.abilityCheckCategoryId = categoryData.categoryId;
    this.doActions([
      {
        path: 'abilityCheckItem/export',
        payload: {
          key: 'abilityCheckItemExport',
          apiParams: {
            abilityCheckCategoryId: categoryData.categoryId,
            ...categoryData
          }
        },
      }
    ])


  }

  _update = (record) => {
    record.positionsName = this.initialValue.positionsName
    record.orgName = this.initialValue.orgName
    record.categoryName = this.initialValue.categoryName
    record.categoryState = this.initialValue.state == 1 ? "有效" : "无效"
    record.categoryId = this.initialValue.categoryId
    this.jumpPage('push', '/train/abilityCheckCategory/abilityCheckItem/abilityCheckItemUpd', { ...record });
  }

  _changeState = (record) => {
    const content = `您确定要${
      record['state'] === 0 ? "启用" : "禁用"
      }该能力评估星级？`;

    WizModal.confirm({
      title: "注意",
      content,
      onOk: () => {
        this.doAction({
          path: 'abilityCheckItem/updateState',
          payload: {
            key: 'abilityCheckItemState',
            apiParams: { id: record.id, state: record.state === 0 ? 1 : 0 }
          },
          autoInit: true,
        })
      },
      onCancel() {
      }
    });
  }

  propsAndStateOnChange = {
    abilityCheckItemState: this.abilityCheckItemStateOver.bind(this),
    abilityCheckItemExport: this._handleFile.bind(this),
  };

  /**
     * 修改状态返回结果
     * @param nextProps
     * @param nextState
     */
  abilityCheckItemStateOver(nextProps, nextState) {
    if (nextProps.abilityCheckItemState.code == 1) {
      this.getDataList();
      wizNotice.success('状态修改成功');
    } else {
      wizNotice.error('状态修改失败：' + nextProps.abilityCheckItemState.msg);
    }
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (selectedRows, categoryData) => {
    let r = []
    let btns = new Map();
    btns.set('add', <WizButton icon="plus" type="primary" onClick={() => this._add(categoryData)}>新增</WizButton>);
    btns.set('export', <WizButton type="export" onClick={() => this._export(categoryData)}>导出</WizButton>);
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }
  /**能力评估星级列表 */
  dataList(categoryData) {
    const { history, abilityCheckItemLoading } = this.props;
    let { selectedRows, rows, signType } = this.state;
    let abilityCheckItem = this.props.abilityCheckItem;
    let supplementary = false;
    let columns = createColumns(this, {}, supplementary);;
    let dataItems = getPageData(abilityCheckItem.data);
    let dataTableProps = {
      loading: false,
      columns,
      dataItems: dataItems,
      rowKey: "id",
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this.getSignInList(signType, { current: pageNum, size: pageSize });
      },
      selectedRowKeys: rows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        this.setState({
          rows,
          selectedRows: rows.length
        })
      }
    };
    return (
      <WizCard className="mt-15">
        <div class="btns-toolbar-group">
          {this._renderBtn(selectedRows, categoryData)}
        </div>
        <WizAlert
          type="info"
          message={<Message selectedRows={selectedRows} removeSelectedRows={this._removeSelectedRows} />}
          showIcon
          style={{ marginBottom: 15 }}
        />
        <WizDataTable {...dataTableProps} />
        <div style={{ marginTop: "20px", "text-align": "center" }}>
          <WizDataTable.Pagination {...dataTableProps} />
        </div>
      </WizCard>
    )
  }


  _render() {
    const { abilityCheckItemLoading } = this.props;
    let positionsName = "";
    let orgName = "";
    let categoryName = "";
    let categoryState = "";
    let categoryId = "";
    if (this.initialValue) {
      positionsName = this.initialValue.positionsName
      orgName = this.initialValue.orgName
      categoryName = this.initialValue.categoryName
      categoryState = this.initialValue.state == 1 ? "有效" : "无效"
      categoryId = this.initialValue.categoryId
    }
    let categoryData = {};
    categoryData.categoryName = categoryName;
    categoryData.orgName = orgName;
    categoryData.positionsName = positionsName;
    categoryData.categoryState = categoryState;
    categoryData.categoryId = categoryId;


    return (
      <Spin tip={'加载中'} spinning={abilityCheckItemLoading}>
        <WizCard title={'能力评估星级管理'}>
          <Row>
            <Col span={1} />
            <Col span={10}>
              <span className="ant-table-column-title" style={{ color: "rgba(0, 0, 0, 0.85)", fontWeight: 500 }}>能力考核项目:</span>
              <span className="ant-table-row-cell-break-word" > {categoryName}</span>
            </Col>
            <Col span={2} />
            <Col span={10}>
              <span className="ant-table-column-title" style={{ color: "rgba(0, 0, 0, 0.85)", fontWeight: 500 }}>品牌:</span>
              <span className="ant-table-row-cell-break-word"> {orgName}</span>
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col span={1} />
            <Col span={10} >
              <span className="ant-table-column-title" style={{ color: "rgba(0, 0, 0, 0.85)", fontWeight: 500 }}>岗位:</span>
              <span className="ant-table-row-cell-break-word"> {positionsName}</span>
            </Col>
            <Col span={2} />
            <Col span={10}>
              <span className="ant-table-column-title" style={{ color: "rgba(0, 0, 0, 0.85)", fontWeight: 500 }}>状态:</span>
              <span className="ant-table-row-cell-break-word"> {categoryState}</span>
            </Col>
          </Row>
        </WizCard>
        <WizCard>
          {this.dataList(categoryData)}
        </WizCard>
      </Spin>
    )
  }
}

const Message = ({ selectedRows, removeSelectedRows }) => (
  <>
    已选择 {selectedRows} 项
    <WizButton
      style={{ height: 20 }}
      type="link"
      tooltip="清空"
      onClick={() => removeSelectedRows()}
    >
      {" "}
      清空
    </WizButton>
  </>
);


const mapStateToProps = (state, ownProps) => {
  const { abilityCheckItem } = state;
  const abilityCheckItemData = modelUtils.getModelEntity(abilityCheckItem, "abilityCheckItem");
  const abilityCheckItemState = modelUtils.getModelEntity(abilityCheckItem, "abilityCheckItemState");
  const abilityCheckItemExport = modelUtils.getModelEntity(abilityCheckItem, "abilityCheckItemExport");
  const load = modelUtils.getLoadingState(state, ['abilityCheckItem']);
  return {
    abilityCheckItem: abilityCheckItemData,
    abilityCheckItemState: abilityCheckItemState,
    abilityCheckItemExport: abilityCheckItemExport,
    ...load
  }
};

export default connect(mapStateToProps)(AbilityCheckItemList);
